<aside class="main-sidebar elevation-4" *ngIf="isShown && isMenuReady && !isWizardShown">
  <a href="/" class="brand-link logo-switch" [title]="'Evidentist'">
    <img src="assets/img/logo.svg" alt="Depoto" class="brand-image-xl logo-xs" data-cy="small-logo" />
    <img src="assets/img/logo-evidentis.svg" alt="Depoto" class="brand-image-xs logo-xl" data-cy="big-logo" />
  </a>

  <div class="sidebar">
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="true">
        <ng-container *ngFor="let item of menuItems">
          <ng-template [ngIf]="item && !item.sublinks && item.show">
            <li class="nav-item">
              <a
                [routerLink]="item.link"
                (click)="setLastOpenedSubTree(''); item.action && item.action()"
                class="nav-link nav-link-main"
                [ngClass]="{ active: isActiveLink(item) }"
                [title]="item.htmlTitle"
              >
                <i class="nav-icon far fa-{{ item.icon }}"></i>
                <p class="nav-link-label" data-cy="nav-items">{{ item.title }}</p>
              </a>
            </li>
          </ng-template>
          <ng-template [ngIf]="item && item.sublinks && item.show">
            <li
              class="nav-item has-treeview"
              [ngClass]="{ 'menu-open': item.title === lastOpenedSubTree, active: isSubmenuActive(item) }"
              [id]="item.title"
            >
              <a
                href="#"
                class="nav-link submenu-main"
                [title]="item.htmlTitle"
                [ngClass]="{ active: isSubmenuActive(item) }"
              >
                <i class="nav-icon far fa-{{ item.icon }}"></i>
                <p class="nav-link-label" data-cy="more-nav-items">{{ item.title }}</p>
                <i class="right fa fa-angle-right"></i>
              </a>
              <ul class="nav nav-treeview submenu">
                <ng-container *ngFor="let subitem of item.sublinks">
                  <ng-template [ngIf]="subitem.show">
                    <li class="nav-item" [ngClass]="{ 'active-border': isActiveLink(subitem) }">
                      <a
                        [routerLink]="subitem.link"
                        (click)="setLastOpenedSubTree(item.title)"
                        class="nav-link nav-link-sub"
                        [ngClass]="{ 'active-submenu': isActiveLink(subitem) }"
                        [title]="subitem.htmlTitle"
                      >
                        <i class="nav-icon far fa-{{ subitem.icon }}"></i>
                        <p data-cy="sub-nav-items">{{ subitem.title }}</p>
                      </a>
                    </li>
                  </ng-template>
                </ng-container>
              </ul>
            </li>
          </ng-template>
        </ng-container>
      </ul>
    </nav>
  </div>
</aside>
